module.exports = __webpack_public_path__ + "static/media/carbon-dioxide-2.5a2edc3e.svg";